import Field from "../../../shared/ui/Field/Field";
import TextInput from "../../../shared/ui/Field/TextInput";

// CompanyContactField — leaf view for one editable row in the company
// contact form. Selector-free, dispatch-free; consumes its data via
// props only. Thin feature-local wrapper that ties the field name to a
// controlled handler. Kept separate from the widget per
// migration/phase9-text-form-plan.md §8.2 "split during transcription".

function CompanyContactField({
  name,
  label,
  help,
  type = "text",
  value,
  error,
  placeholder,
  maxLength,
  autoComplete,
  disabled = false,
  onValueChange,
}) {
  const handleChange = (event) => {
    if (!onValueChange) return;
    onValueChange(name, event.target.value);
  };

  return (
    <Field
      id={`company-contact-${name}`}
      label={label}
      help={help}
      error={error}
      className="feature-company-contact__field"
    >
      <TextInput
        name={name}
        type={type}
        value={value ?? ""}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={maxLength}
        autoComplete={autoComplete}
        disabled={disabled}
      />
    </Field>
  );
}

export default CompanyContactField;
